/**
 * HTML Entity Decode Tool
 */

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import { ToolError } from '@/engine/errors/ToolError';
import type { ITransformerTool } from '@/interfaces/ITool';

export const HtmlEntityDecodeTool: ITransformerTool = {
  id: 'html-entity-decode',
  name: 'HTML Entity Decode',
  description: 'Decode HTML entities into characters',
  version: '1.0.0',
  type: 'transformer',
  category: 'Encoders & Decoders',
  keywords: ['html', 'entity', 'decode', 'unescape'],

  supportedInputTypes: [SEMANTIC_TYPES.TEXT, SEMANTIC_TYPES.HTML],
  outputType: SEMANTIC_TYPES.TEXT,

  attributes: [],

  async transform(input: string): Promise<string> {
    try {
      const el = document.createElement('textarea');
      el.innerHTML = input;
      return el.value;
    } catch {
      throw ToolError.validation('Invalid HTML entity input');
    }
  },
};
